import React from 'react';

import { Box, Stack, xcss } from '@atlaskit/primitives';
import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

export const LeftHandSideWrapper = ({
	children,
	isIllustrationRefresh = false,
}: {
	children: React.ReactNode;
	isIllustrationRefresh?: boolean;
}) => {
	return (
		<Box
			xcss={wrapperStyles}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
			style={
				isIllustrationRefresh
					? {
							paddingBlock: token('space.800', '64px'),
							paddingInlineStart: token('space.800', '64px'),
							paddingInlineEnd: token('space.800', '64px'),
						}
					: undefined
			}
		>
			<Stack spread="space-between" xcss={stackStyles}>
				{children}
			</Stack>
		</Box>
	);
};

const wrapperStyles = xcss({
	backgroundColor: 'elevation.surface',
	padding: 'space.300',
	[media.above.sm]: {
		padding: 'space.800',
	},
});

const stackStyles = xcss({
	height: '100%',
});
